import type { FaireProductEntity } from "../../entity_types/product";

export const p_dvnpxx39by: FaireProductEntity = {
  token: "p_dvnpxx39by",
  type: "product",
  name: "Black Cat, Moon and Mushroom Mug Purple Glaze",
  brandToken: "b_qpb3ygknfs",
  brandName: "Divine Vessels Pottery",
  imageUrl:
    "https://cdn.faire.com/fastly/b2e37e19ea6ea3255a45a81480de8ef6060248f7d6a081a085276e0fb66debfb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6392df0bbeff21413c8428f7799db19684620577bffddf2e4a458b0c0e8a4558.jpeg",
    "https://cdn.faire.com/fastly/7ab34f4affc825c6fd6f533595ffdcb467102dd59c1f01adf4abe0e569da7a7c.jpeg",
    "https://cdn.faire.com/fastly/a87e7a6a9ad024f1016f3f326ac00f8ca61b3568f4fa9a89964735ac0e8dc632.jpeg",
    "https://cdn.faire.com/fastly/abce4917067a67257ca115be5f3249629f586f9406b92ad30d20f62f3f8762f0.jpeg",
    "https://cdn.faire.com/fastly/edf540f7d0f758d8a59b7a1a7fd6b714dde764ddc8e594a63f50e9bce3e22da1.jpeg",
    "https://cdn.faire.com/fastly/1ff7a3503b03c223e786250899337f7f376731a32070c24aea94716657a56a93.jpeg",
  ],
  priceDollars: 27.71,
  description:
    "This handcrafted mug features a captivating blend of blue and purple glaze, accented by a whimsical emblem depicting a black cat, moon and mushroom. Its artistic design makes it a unique addition to any collection, perfect for enjoying your favorite hot beverages with a touch of whimsy and elegance. Durable and comfortable to hold, this mug combines functionality with expert craftsmanship.\n\n* Holds 12 oz. \n* Handmade in the USA\n* Woman owned business \n* Each piece is carefully handcrafted by the artist so there are slight variations from the                      item pictured. \n* This is stoneware pottery known for its rugged qualities\n* Dishwasher, microwave and oven safe. \n",
  tags: [],
  msrpDollars: 55.43,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:20.444Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
